import { Box, Flex } from "@chakra-ui/react";
import { CardTable } from "components/CardTable";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { api } from "services/api";
import utils from "utils";
import storage from "utils/storage";

// const demodata = [
//   {
//     id: 1,
//     c1: "item label1",
//     c2: 0,
//     c3: "$0.0",
//   },
//   {
//     id: 2,
//     c1: "item label2",
//     c2: 0,
//     c3: "$0.0",
//   },
//   {
//     id: 3,
//     c1: "item label3",
//     c2: 0,
//     c3: "$0.0",
//   },
// ];

function Status() {
  const [invoiceData, setInvoiceData] = useState([]);
  const [claimData, setClaimData] = useState([]);
  const [agreementsData, setAgreementsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dealers, setDealers] = useState([]);

  const onDealerChange = ({ dealerid }) => {
    setIsLoading(true);
    console.log("getStatus", dealerid);

    api.getStatus({ dealerid }).then((res) => {
      console.log("getStatus", res?.data);
      setIsLoading(false);
      if (res?.status === 200) {
        setAgreementsData([
          {
            id: "not invoiced",
            c1: "Not Invoiced",
            c2: utils.formatNum(res?.data?.policynotinvoiced), //res?.data?.invoicespending || 0,
            c3: " ", //`$ ${res?.data?.invoicespendingtotal || 0}`,
          },
          {
            id: "invoiced",
            c1: "Invoiced",
            c2: utils.formatNum(res?.data?.policyinvoiced),
            c3: utils.formatCurrency(res?.data?.policyinvoicedtotal),
          },
          {
            id: "pending",
            c1: "Pending",
            c2: utils.formatNum(res?.data?.policypending),
            c3: utils.formatCurrency(res?.data?.policypendingtotal),
          },
          {
            id: "Paid",
            c1: "Paid",
            c2: utils.formatNum(res?.data?.policypaid),
            c3: utils.formatCurrency(res?.data?.policypaidtotal),
          },
          {
            id: "paid vat",
            c1: "Paid Vat",
            c2: utils.formatNum(res?.data?.policypaid),
            c3: utils.formatCurrency(res?.data?.policypaidvattotal),
          },
          {
            id: "total",
            c1: "Total",
            c2: utils.formatNum(res?.data?.policycount),
            c3: utils.formatCurrency(res?.data?.policycounttotal),
          },
        ]);

        setInvoiceData([
          {
            id: "pending",
            c1: "Pending",
            c2: utils.formatNum(res?.data?.invoicespending),
            c3: utils.formatCurrency(res?.data?.invoicespendingtotal),
          },
          {
            id: "paid",
            c1: "Paid",
            c2: utils.formatNum(res?.data?.invoicespaid),
            c3: utils.formatCurrency(res?.data?.invoicespaidtotal),
          },
          {
            id: "total",
            c1: "Total",
            c2: utils.formatNum(res?.data?.totalinvoices),
            c3: utils.formatCurrency(res?.data?.invoicestotal),
          },
        ]);

        setClaimData([
          {
            id: "submited",
            c1: "Submited",
            c2: utils.formatNum(res?.data?.claimssubmitted),
            c3: utils.formatCurrency(res?.data?.claimssubmittedtotal),
          },
          {
            id: "accepted",
            c1: "Accepted",
            c2: utils.formatNum(res?.data?.claimsaccepted),
            c3: utils.formatCurrency(res?.data?.claimsacceptedtotal),
          },
          {
            id: "Pending Payment / Awaiting Documents",
            c1: "Pending Payment / Awaiting Documents",
            c2: utils.formatNum(res?.data?.claimdocuments),
            c3: utils.formatCurrency(res?.data?.claimdocumentstotal),
          },
          {
            id: "total",
            c1: "Total Claims",
            c2: utils.formatNum(res?.data?.claimscount),
            c3: " ",
          },

          {
            id: "refund-amount",
            c1: "Refundable Amount (Paid Invoices)",
            c2: " ",
            c3: utils.formatCurrency(res?.data?.policynettotal),
          },
          {
            id: "Funds Paid In",
            c1: "Funds Paid In",
            c2: " ",
            c3: utils.formatCurrency(res?.data?.fundsreceived),
          },
          {
            id: "Funds Returned",
            c1: "Funds Returned",
            c2: " ",
            c3: utils.formatCurrency(res?.data?.fundsreturned),
          },
          {
            id: "Claims Paid",
            c1: "Claims Paid",
            c2: utils.formatNum(res?.data?.claimspaid),
            c3: utils.formatCurrency(res?.data?.claimspaidtotal),
          },
          {
            id: "required-funds",
            c1: "Required Funds",
            c2: " ",
            c3: utils.formatCurrency(res?.data?.refundafter),
          },
          {
            id: "Balance",
            c1: "Balance",
            c2: " ",
            c3: utils.formatCurrency(res?.data?.balance),
          },
        ]); 
      } else {
        toaster.create({
          title: res?.message,
          type: "error",
        });
      }
    });
  };

  const onDdChange = (data) => {
    setDealers(data.list);
    if (data?.item?.data?.dealerid || data?.item?.data?.dealerid === 0) {
      onDealerChange({ dealerid: data.item.data.dealerid });
    }

    const appcatch = storage.get("appcatch") || {};
    appcatch.status_dealerid = data?.item?.data?.dealerid;
    storage.set("appcatch", appcatch);
  };

  // useEffect(() => {
  //   setIsLoading(true);
  //   api.getDealers().then((res) => {
  //     console.log('getDealers res', res);
  //     setIsLoading(false);

  //     if (res?.status === 200) {
  //       if (res?.data && res?.data[0]) {
  //         let dea = [];

  //         dea = res.data.map((a, index) => ({
  //           key: `dealer-${index}`,
  //           value: `${a.companyname}-${index}`,
  //           label: a.companyname,
  //           data: { dealerid: a.dealerid },
  //         }));

  //         const arr = [
  //           // {
  //           //   key: "dealer-all",
  //           //   value: "all",
  //           //   label: "All",
  //           //   data: { dealerid: 0 },
  //           // },
  //           ...dea,
  //         ];
  //         arr[0].selected = true;

  //         setDealers(arr);
  //         onDealerChange({ dealerid: arr[0]?.data?.dealerid });
  //       }
  //     } else {

  //       toaster.create({
  //         title: res?.message,
  //         type: "error",
  //       });
  //     }
  //   });
  // }, []);

  useEffect(() => {
    const cb = async () => {
      const appcatch = storage.get("appcatch") || {};
      await utils.getDealers({
        setIsLoading,
        action: "useState",
        onDealersChange: onDdChange,
        allOption: false,
        defaultVal: appcatch?.status_dealerid,
      });
    };
    cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Box w={"100%"}>
        <Header label={"Status"} isLoading={isLoading} />
        <InputComp
          // w={"20rem"}
          type={"dropdown"}
          items={dealers}
          onChange={onDdChange}
          placeholder={"Select Account"}
        />
      </Box>
      <Flex flexFlow={"wrap"} overflow={"scroll"} gap="2">
        <CardTable label={"Agreements"} items={agreementsData} />
        <CardTable label={"Invoices"} items={invoiceData} />
        <CardTable label={"Claims"} items={claimData} />
      </Flex>
    </Flex>
  );
}

export default Status;
